import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Globe — meridian line scrolls horizontally, suggesting rotation.
 *  The globe outline + equator stay put so readability is preserved
 *  at 16 px; animating `stroke-dashoffset` keeps compositor-cheap. */
export function IcnGlobe(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="globe">
      <circle cx="8" cy="8" r="6" />
      {/* Equator */}
      <line x1="2" y1="8" x2="14" y2="8" />
      {/* Animated meridian — dash offset travels to simulate rotation */}
      <ellipse cx="8" cy="8" rx="3" ry="6" strokeDasharray="4 3" strokeDashoffset="0">
        {animate && (
          <animate
            attributeName="stroke-dashoffset"
            from="0"
            to="7"
            dur="4s"
            repeatCount="indefinite"
          />
        )}
      </ellipse>
      {/* Static pole-to-pole meridian for stability */}
      <line x1="8" y1="2" x2="8" y2="14" />
    </Svg>
  );
}
